import Vue from 'vue'

export const JustDnD = () => {

    function move(e, params) {
        e.preventDefault()
        e.stopPropagation()

        const
            targetEl = e.target,
            parentEl = targetEl.parentElement,
            parentElRect = parentEl.getBoundingClientRect(),
            shiftX = e.pageX - parentElRect.left - targetEl.offsetLeft,
            shiftY = e.pageY - parentElRect.top - targetEl.offsetTop

        function moveAt(e) {
            const
                leftPX = e.pageX - parentElRect.left - shiftX,
                topPX = e.pageY - parentElRect.top - shiftY

            if (leftPX >= 0 && leftPX <= parentElRect.width)
                params.left = Math.round(100 / parentElRect.width * leftPX * 10) / 10

            if (topPX >= 0 && topPX <= parentElRect.height)
                params.top = Math.round(100 / parentElRect.height * topPX * 10) / 10
        }

        function mouseMove(e) {
            params.isActive = true
            
            moveAt(e)
        }

        function mouseUp(e) {
            params.isActive = false

            moveAt(e)

            document.removeEventListener('mousemove', mouseMove)
            document.removeEventListener('mouseup', mouseUp)
        }

        moveAt(e)

        document.addEventListener('mousemove', mouseMove)
        document.addEventListener('mouseup', mouseUp)
    }

    Vue.directive('dnd', {

        bind: (el, binding) => {
            el.addEventListener('mousedown', e => move(e, binding.value))
        },
    })
}


export const JustRotate = () => {

    function rotate(e, params) {
        e.preventDefault()
        e.stopPropagation()

        const
            targetEl = e.target,
            parentEl = targetEl.parentElement,
            parentElRect = parentEl.getBoundingClientRect(),
            stickerPos = {x: Math.round(parentElRect.left), y: Math.round(parentElRect.top)},
            stickerSize = parentElRect.width

        function rotateAt(e) {
            const
                radians = Math.atan2( (e.pageX - stickerSize / 2) - stickerPos.x, ((e.pageY - window.scrollY) - stickerSize / 2) - stickerPos.y ),
                degrees = Math.round((radians * (180 / Math.PI) * -1) - 180)

            params.angle = degrees
        }

        function mouseMove(e) {
            params.isActive = true

            rotateAt(e)
        }

        function mouseUp(e) {
            params.isActive = false

            rotateAt(e)

            document.removeEventListener('mousemove', mouseMove)
            document.body.removeEventListener('mouseup', mouseUp)
        }

        rotateAt(e)

        document.addEventListener('mousemove', mouseMove)
        document.body.addEventListener('mouseup', mouseUp)
    }

    Vue.directive('rotate', {

        bind: (el, binding) => {
            el.addEventListener('mousedown', e => rotate(e, binding.value))
        },
    })
}


export const JustResize = () => {

    function rotate(e, params) {
        e.preventDefault()
        e.stopPropagation()

        const
            targetEl = e.target,
            parentEl = targetEl.parentElement,
            stickerPos = {x: parentEl.offsetLeft, y: parentEl.offsetTop},
            previewEl = parentEl.parentElement,
            previewElRect = previewEl.getBoundingClientRect(),
            stickerBaseSize = previewElRect.width / 100 * 10

        function resizeAt(e) {
            const
                x = Math.round(e.pageX - previewElRect.left),
                y = Math.round(e.pageY - previewElRect.top - window.scrollY)

            const
                a = stickerPos.x - x,
                b = stickerPos.y - y

            const
                currentDistance = Math.sqrt( a * a + b * b )

            const
                size = Math.sqrt(currentDistance * currentDistance / 2 ) * 2 / stickerBaseSize

            if (size > 1.5 || size < .5) return null

            params.scale = Math.round(size * 100) / 100
        }

        function mouseMove(e) {
            params.isActive = true

            resizeAt(e)
        }

        function mouseUp(e) {
            params.isActive = false

            resizeAt(e)

            document.removeEventListener('mousemove', mouseMove)
            document.removeEventListener('mouseup', mouseUp)
        }

        resizeAt(e)

        document.addEventListener('mousemove', mouseMove)
        document.addEventListener('mouseup', mouseUp)
    }

    Vue.directive('resize', {

        bind: (el, binding) => {
            el.addEventListener('mousedown', e => rotate(e, binding.value))
        },
    })
}